import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as customappsActions from "../actions/customapps";
import * as userActivityActions from "../actions/userActivity";
import {
  getUserActivityCustomAppIdValueFromStore,
  getUserActivityCurrentSessionValueFromStore,
} from "../services/utils";

import RaisedButton from "material-ui/RaisedButton";
import _ from "lodash";
import IconEmail from "material-ui/svg-icons/communication/email";
import IconStar from "material-ui/svg-icons/action/stars";
import IconCopy from "material-ui/svg-icons/content/content-copy";
import IconMore from "material-ui/svg-icons/navigation/more-vert";
import IconMenu from "material-ui/IconMenu";
import IconPrint from "material-ui/svg-icons/action/print";
import IconActivity from "../resources/icons/activity.png";
import IconGoalFlag from "../resources/icons/goal-flag.png";
import IconMessage from "../resources/icons/message.png";
import IconCustom from "../resources/icons/custom.png";
import IconLibrary from "../resources/icons/library.png";
import moment, { now } from "moment";
import Divider from "material-ui/Divider";
import IconReport from "material-ui/svg-icons/editor/insert-chart";

import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionActions from "@material-ui/core/AccordionActions";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import IconDelete from "material-ui/svg-icons/action/delete";
import IconEdit from "material-ui/svg-icons/image/edit";
import { Tooltip } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";

import AppFrame from "./Appframe/AppFrame";
import Title from "../components/common/Title";
import NormalFlatButton from "../components/common/NormalFlatButton";
import NormalBigButton from "../components/common/NormalBigButton";
import CategorySelector from "./playbook/CategorySelector";
import CustomCategoryEditor from "./playbook/CustomCategoryEditor";
import PushNotificationSender from "../components/common/PushNotificationSender";
import WrapDialogue from "../components/common/WrapDialogue";
import ActionButton from "../components/common/ActionButton";
import colors, { colorsV2 } from "../styles/colors";
import layout from "../styles/layout";
import textStyle from "../styles/text";
import { generatePdf } from "./utils/pdfUtils";
import { getLocalDT } from "./utils/timeUtils";

import ProgramSelector from "../components/common/ProgramSelector";
import CustomAppService from "../services/customapps";

import LibraryInstructionPrint from "./playbook/LibraryInstructionPrint";
import InstructionView from "../components/common/InstructionView";
import events from "../services/events";
import TimerDisplay from "../components/rtm/TimerDisplay";

import CustomAppProgramEdit from "../components/common/CustomAppProgramEdit";

import LogInteractionPopup from "../components/rtm/LogInteractionPopup";
import {
  Button,
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import SortIcon from "@material-ui/icons/SwapVert";
import IconButton from "material-ui/IconButton";
import SmallActionButton from "../components/common/SmallActionButton";

import MenuIcon from "@material-ui/icons/Menu";
import {
  sortableElement,
  sortableContainer,
  arrayMove,
} from "react-sortable-hoc";
import SortableInstruction from "../components/common/SortableInstruction";
import SortableProgram from "../components/common/SortableProgram";
const style = {
  playbookContainer: {
    width: "75%",
    borderRadius: 16,
    borderWidth: 1,
    borderColor: colors.text,
    padding: 4,
  },
  userChannelHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  topMenuButtonsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    flexWrap: "wrap",
    marginTop: 25,
    marginBottom: 15,
  },
  timerDisplayContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    flexWrap: "wrap",
  },
  button: {
    width: 160,
    border: "2px solid grey",
    borderRadius: 8,
    padding: 4,
    marginRight: 4,
    marginLeft: 4,
  },
  buttonImage: {
    width: 24,
    height: 24,
    padding: 5,
    margin: 0,
    border: "2px solid #52829D",
    borderRadius: 18,
  },
};

class ManageUserCustomApp extends Component {
  constructor(props) {
    super(props);

    let appId = props.match.params.appId;
    let userId = props.match.params.userId;
    let appInfo = this.props.apps.appInfos[appId];
    let userInfo = {};
    if (this.props.appusers.appUsers[appId]) {
      userInfo = _.find(this.props.appusers.appUsers[appId], [
        "userId",
        parseInt(userId, 10),
      ]).userInfo;
    }
    let userName = userInfo.lastName
      ? `${userInfo.firstName} ${userInfo.lastName}`
      : userInfo.email;

    this.state = {
      appId,
      userId,
      appInfo,
      userInfo,
      userName,
      customapp: {},
      customappTemplate: {},
      templateCategories: [],
      selectedCategory: {},
      feedbackReportCategories: {},
      width: 0,
      height: 0,
      showPrint: false,
      showPopup: false,
      orderModalOpen: false,
      instructions: [],
      programInstructions: [],
      needsReset: false,
      tabIndex: 0,
      libraryDialogOpen: false,
      editProgram: null,
      editProgramModalOpen: false,
      expandedProviderProgramId: null,
      deletingProgramId: null,
      awaitingDeleteRefresh: false,
    };

    this.deleteRefreshTimeout = null;

    this.addLibrary = this.addLibrary.bind(this);
    this.addNewCategory = this.addNewCategory.bind(this);
    this.removeCategory = this.removeCategory.bind(this);
    this.editCategory = this.editCategory.bind(this);
    this.viewCategory = this.viewCategory.bind(this);
    this.editCategoryDialogue = this.editCategoryDialogue.bind(this);
    this.viewCategoryDialogue = this.viewCategoryDialogue.bind(this);
    this.sendPushNotification = this.sendPushNotification.bind(this);
    this.feedbackReport = this.feedbackReport.bind(this);
    this.viewFeedback = this.viewFeedback.bind(this);
    this.archiveActivate = this.archiveActivate.bind(this);
    this.backPressed = this.backPressed.bind(this);
    this.logEventAndNavBack = this.logEventAndNavBack.bind(this);
    this.setShowPopup = this.setShowPopup.bind(this);
    this.closeOrderModal = this.closeOrderModal.bind(this);
    this.openOrderModal = this.openOrderModal.bind(this);
    this.handleSaveOrder = this.handleSaveOrder.bind(this);
    this.handleSaveProgramOrder = this.handleSaveProgramOrder.bind(this);
    this.onSortEnd = this.onSortEnd.bind(this);
    this.handleDeleteProgram = this.handleDeleteProgram.bind(this);
    this.clearDeleteRefreshTimeout = this.clearDeleteRefreshTimeout.bind(this);
  }

  clearDeleteRefreshTimeout() {
    if (this.deleteRefreshTimeout) {
      clearTimeout(this.deleteRefreshTimeout);
      this.deleteRefreshTimeout = null;
    }
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    let updatedOrder = arrayMove(this.state.instructions, oldIndex, newIndex);
    this.setState({
      instructions: updatedOrder,
    });
  };

  onProgramSortEnd = ({ oldIndex, newIndex }) => {
    let updatedOrder = arrayMove(
      this.state.customapp.programs,
      oldIndex,
      newIndex
    );
    let updatedCustomApp = this.state.customapp;
    updatedCustomApp.programs = updatedOrder;
    this.setState({
      customapp: updatedCustomApp,
    });
  };

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener(
      "resize",
      this.updateWindowDimensions.bind(this)
    );
    this.clearDeleteRefreshTimeout();
  }

  componentWillMount() {
    this.props.fetchCustomApp(this.state.appId, this.state.userId);
    this.props.getCustomAppTemplate(this.state.appId);
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.customapps &&
      nextProps.customapps.customApps &&
      nextProps.customapps.customApps[this.state.appId]
    ) {
      let customapp =
        nextProps.customapps.customApps[this.state.appId][this.state.userId];
      let instructions = [];

      //create an array of instruction like objects for sort
      if (customapp && customapp.categories) {
        instructions = Object.keys(customapp.categories).map((key) => {
          return {
            id: customapp.categories[key].categoryId,
            name: customapp.categories[key].categoryName,
            group: customapp.categories[key].groupName,
            desc: customapp.categories[key].categoryDesc,
            archived: customapp.categories[key].archived,
          };
        });
      }

      if (customapp) {
        const fetchComplete =
          nextProps.customapps && !nextProps.customapps.isLoading;
        const deleteRefreshState =
          this.state.awaitingDeleteRefresh && fetchComplete
            ? { deletingProgramId: null, awaitingDeleteRefresh: false }
            : {};
        if (this.state.awaitingDeleteRefresh && fetchComplete) {
          this.clearDeleteRefreshTimeout();
        }
        this.setState({ customapp, instructions, ...deleteRefreshState });
      }

      if (nextProps.customapps && nextProps.customapps.programInstructions) {
        this.setState({
          programInstructions: nextProps.customapps.programInstructions,
        });
      }
    }
    let customappTemplate =
      nextProps.customapps.customAppTemplates[this.state.appId];
    if (customappTemplate) {
      let templateCategories = [];
      customappTemplate.template.groups.forEach((group) => {
        templateCategories = _.concat(templateCategories, group.categories);
      });
      this.setState({
        customappTemplate,
        templateCategories,
      });
    }
    let appInfo = nextProps.apps.appInfos[this.state.appId];
    if (appInfo) {
      this.setState({ appInfo });
    }
    if (nextProps.appusers.appUsers[this.state.appId]) {
      let user = _.find(nextProps.appusers.appUsers[this.state.appId], [
        "userId",
        parseInt(this.state.userId, 10),
      ]);
      if (user) {
        this.setState({ userInfo: user.userInfo });
      }
    }
  }

  copyTextToClipboard(text, msg) {
    if (!navigator.clipboard) {
      // fallbackCopyTextToClipboard(text);
      return;
    }
    navigator.clipboard.writeText(text).then(
      () => {
        alert(msg);
      },
      (err) => {
        alert("Unable to copy the HEP to your clipboard");
      }
    );
  }

  fallbackCopyTextToClipboard() {}

  copyHEPForEMR() {
    let pasteVal = "";
    _.values(this.state.customapp.categories).map((category) => {
      pasteVal += this.getPasteValForCategory(category);
    });

    this.copyTextToClipboard(pasteVal, "Full HEP Copied To The Clipboard");
  }

  copyForEMR(category) {
    let pasteVal = this.getPasteValForCategory(category);
    this.copyTextToClipboard(pasteVal, "Instruction Copied To The Clipboard");
  }

  getPasteValForCategory(category) {
    let pasteVal = category.categoryName;
    pasteVal += "\r\n----------------------------------------------";
    pasteVal += !!category.createdAt
      ? "\r\nCreated: " + this.getPrintableDate(category.createdAt.seconds)
      : "";
    pasteVal += !!category.modifiedAt
      ? "\r\nLast Modified: " +
        this.getPrintableDate(category.modifiedAt.seconds)
      : "";
    pasteVal += !!category.categoryDesc
      ? "\r\nInstruction: " + category.categoryDesc
      : "";
    pasteVal += !!category.numSets ? "\r\nSets: " + category.numSets : "";
    pasteVal += !!category.numRepetitions
      ? "\r\nReps: " + category.numRepetitions
      : "";
    pasteVal += !!category.frequency
      ? "\r\nFrequency: " + category.frequency
      : "";
    pasteVal += !!category.duration ? "\r\nDuration: " + category.duration : "";

    pasteVal += !!category.intensity
      ? "\r\nIntensity: " + category.intensity
      : "";
    pasteVal += "\r\n";
    pasteVal += "\r\n";
    return pasteVal;
  }

  getPrintableDate(seconds) {
    var curdate = new Date(null);
    curdate.setTime(seconds * 1000);
    return curdate.toLocaleString();
  }

  printUserInstructions() {
    this.setState({ showPrint: true }, () => {
      let containerEl = document.createElement("div");
      const input = document.getElementById("printDiv");
      let inputClone = input.cloneNode(true);
      input.appendChild(inputClone);
      containerEl.appendChild(inputClone);
      let externalWindow = window.open(
        "",
        "",
        "width=1000,height=500,left=200,top=200"
      );

      externalWindow.document.body.appendChild(containerEl);
      //Trigger automatic print and close window after.
      externalWindow.onafterprint = () => {
        externalWindow.close();
      };
      setTimeout(() => {
        externalWindow.print();
      }, 3000);
      this.setState({ showPrint: false });
    });
  }

  sendPushNotification(userName) {
    let windowTitle = `Send Push Notification to ${userName}`;
    return (
      <div>
        <RaisedButton
          primary={!this.props.whiteLabelSettings.isWhiteLabel}
          label="New Patient App Message"
          icon={<IconEmail />}
          onClick={() => this.refs.sendPushNotificationDialogue.open()}
          style={{ margin: 5 }}
        />
        <WrapDialogue
          ref="sendPushNotificationDialogue"
          title={windowTitle}
          content={
            <PushNotificationSender
              type="user"
              userId={this.props.user.userId}
              appId={this.state.appId}
              appCode={this.props.whiteLabelSettings.appCode}
              recipientUserId={this.state.userId}
              sender={this.state.appInfo ? this.state.appInfo.author : ""}
              subject={this.state.appInfo ? this.state.appInfo.appName : ""}
              onComplete={() => this.refs.sendPushNotificationDialogue.close()}
              whiteLabelSettings={this.props.whiteLabelSettings}
              customApp={this.state.customapp}
            />
          }
        />
      </div>
    );
  }

  removeCategory(category) {
    let categoryId = [category.categoryId];
    this.props.removeCategoriesFromCustomApp(
      this.state.appId,
      this.state.userId,
      this.state.customapp.customAppId,
      categoryId
    );
  }

  archiveActivate(category) {
    let categoryToUpdate = category;
    categoryToUpdate.archived = !category.archived;
    this.props.editCustomAppCategory(
      this.state.appId,
      this.state.userId,
      this.state.customapp.customAppId,
      categoryToUpdate.categoryId,
      categoryToUpdate
    );
  }

  editCategory(category) {
    this.setState({
      selectedCategory: category,
    });
    this.refs.editCategoryDialogue.open();
  }

  viewCategory(category) {
    this.setState({
      selectedCategory: category,
    });
    this.refs.viewCategoryDialogue.open();
  }

  editCategoryDialogue() {
    return (
      <WrapDialogue
        ref="editCategoryDialogue"
        title="Edit Instruction"
        content={
          <div>
            <CustomCategoryEditor
              category={this.state.selectedCategory}
              userId={this.state.userId}
              appId={this.state.appId}
              customAppId={this.state.customapp.appId}
              templateId={this.state.customapp.templateId}
              onCancel={() => this.refs.editCategoryDialogue.close()}
              onSave={(category) => {
                this.props.editCustomAppCategory(
                  this.state.appId,
                  this.state.userId,
                  this.state.customapp.customAppId,
                  category.categoryId,
                  category
                );
                this.refs.editCategoryDialogue.close();
                this.setState({ needsReset: true });
              }}
              whiteLabelSettings={this.props.whiteLabelSettings}
            />
          </div>
        }
      />
    );
  }

  viewCategoryDialogue() {
    return (
      <WrapDialogue
        ref="viewCategoryDialogue"
        title="View Instruction"
        content={
          <div>
            <CustomCategoryEditor
              category={this.state.selectedCategory}
              userId={this.state.userId}
              appId={this.state.appId}
              customAppId={this.state.customapp.appId}
              templateId={this.state.customapp.templateId}
              readOnly={true}
              whiteLabelSettings={this.props.whiteLabelSettings}
            />
            {this.viewFeedback()}
            <br />
            <div className={"dialog-btns-pationts"}>
              <NormalBigButton
                label="Close"
                onClick={() => this.refs.viewCategoryDialogue.close()}
              />
            </div>
          </div>
        }
      />
    );
  }

  viewFeedback() {
    if (
      this.state.selectedCategory.feedbackList &&
      this.state.selectedCategory.feedbackList.length > 0
    ) {
      let feedbackList = this.state.selectedCategory.feedbackList.reverse();
      return (
        <div>
          <div style={textStyle.subtitle}>Feedback</div>
          {feedbackList.map((feedback, i_feedback) => {
            let localDT = getLocalDT(feedback.time);
            return (
              <div>
                <Divider />
                <p>
                  {localDT} -{" "}
                  <b style={{ color: colors.text }}>{feedback.content}</b>
                </p>
              </div>
            );
          })}
          <Divider />
        </div>
      );
    } else {
      return null;
    }
  }

  addLibrary() {
    let categories = _.differenceBy(
      this.state.templateCategories,
      _.values(this.state.customapp.categories),
      "categoryId"
    );
    const addCategory = (arrayOfCategoryIds) => {
      this.props.addCategoriesToCustomApp(
        this.state.appId,
        this.state.userId,
        this.state.customapp.customAppId,
        arrayOfCategoryIds
      );

      arrayOfCategoryIds.map((id) => {
        events().trackUserEvent(
          "Add New Instruction",
          this.state.appId,
          this.state.customapp.customAppId,
          id,
          null,
          this.props.user.userId,
          this.state.customapp.userId,
          "portal",
          this.state.appInfo.appName,
          null,
          JSON.stringify({ type: "Assign" })
        );
      });

      this.setState({ libraryDialogOpen: false, needsReset: true });
    };
    return (
      <Dialog open={this.state.libraryDialogOpen}>
        <DialogContent>
          <div>
            <AppBar
              position="static"
              style={{ backgroundColor: colorsV2.accent, marginBottom: 15 }}
            >
              <Tabs
                value={this.state.tabIndex}
                onChange={(event, newValue) => {
                  this.setState({ tabIndex: newValue });
                }}
              >
                <Tab label="Assign Instructions" />
                <Tab label="Assign Programs" />
              </Tabs>
            </AppBar>
            {this.state.tabIndex === 0 && (
              <CategorySelector
                categories={categories}
                programs={
                  this.props.apps &&
                  this.props.apps.appTemplates &&
                  this.state.appId &&
                  this.props.apps.appTemplates[this.state.appId] &&
                  this.props.apps.appTemplates[this.state.appId].programs
                    ? this.props.apps.appTemplates[this.state.appId].programs
                    : []
                }
                appFavorite={this.props.apps.appFavorite}
                addFunction={(arrayOfCategoryIds) =>
                  addCategory(arrayOfCategoryIds)
                }
                close={() => this.setState({ libraryDialogOpen: false })}
              />
            )}
            {this.state.tabIndex === 1 && (
              <ProgramSelector
                availablePrograms={
                  this.props.apps &&
                  this.props.apps.appTemplates &&
                  this.state.appId &&
                  this.props.apps.appTemplates[this.state.appId] &&
                  this.props.apps.appTemplates[this.state.appId].programs
                    ? this.props.apps.appTemplates[this.state.appId].programs
                    : []
                }
                onSave={() => {
                  this.props.fetchCustomApp(
                    this.state.appId,
                    this.state.userId
                  );
                  this.setState({ libraryDialogOpen: false });
                }}
                assignedPrograms={this.state.customapp.programs}
                customApp={this.state.customapp}
                close={() => this.setState({ libraryDialogOpen: false })}
              />
            )}
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  addNewCategory() {
    let emptyCategory = {};
    return (
      <WrapDialogue
        ref="addNewCategoryDialogue"
        title="New Instruction"
        content={
          <CustomCategoryEditor
            category={emptyCategory}
            userId={this.state.userId}
            appId={this.state.appId}
            customAppId={this.state.customapp.appId}
            templateId={this.state.customapp.templateId}
            onCancel={() => this.refs.addNewCategoryDialogue.close()}
            onSave={(category) => {
              this.props.addUserCategoryToCustomApp(
                this.state.appId,
                this.state.userId,
                this.state.customapp.customAppId,
                category
              );

              events().trackUserEvent(
                "Add New Instruction",
                this.state.appId,
                this.state.customapp.customAppId,
                null,
                null,
                this.props.user.userId,
                this.state.customapp.userId,
                "portal",
                this.state.appInfo.appName,
                category.categoryName,
                JSON.stringify(category)
              );

              this.setState({ needsReset: true });
              this.refs.addNewCategoryDialogue.close();
            }}
            whiteLabelSettings={this.props.whiteLabelSettings}
          />
        }
      />
    );
  }

  feedbackReport() {
    let removeCategoryFromReport = (category) => {
      let updatedCategories = this.state.feedbackReportCategories;
      _.remove(updatedCategories, function (c) {
        return c.categoryId === category.categoryId;
      });
      this.setState({ feedbackReportCategories: updatedCategories });
    };

    let exportFeedbackReport = () => {
      // report content
      let reportName = `${this.state.userName} Feedback Report of ${this.state.appInfo.appName}.pdf`;
      let reportTitle =
        "Feedback Report - " +
        this.state.appInfo.appName +
        " - " +
        this.state.userName;
      let reportContent = reportTitle + "\n";
      _.forEach(this.state.feedbackReportCategories, function (category) {
        reportContent += "\n----------\n\n";
        reportContent +=
          category.groupName + ": " + category.categoryName + "\n\n";
        if (category.categoryDesc) {
          reportContent += category.categoryDesc + "\n";
        }
        if (category.categoryContent) {
          reportContent += category.categoryContent + "\n";
        }
        reportContent += "\nFeedback\n";
        if (category.feedbackList && category.feedbackList.length > 0) {
          _.forEach(category.feedbackList, function (feedback) {
            let gmtDateTime = moment.utc(feedback.time, "YYYY-MM-DD hh:mmA");
            let localDT = gmtDateTime.local().format("YYYY-MM-DD h:mm A");
            reportContent += feedback.content + "  (" + localDT + ") \n";
          });
        } else {
          reportContent += "None\n";
        }
      });
      // generate report PDF
      generatePdf(reportName, reportContent);
    };

    return (
      <div>
        {/*
        <RaisedButton
          primary={!this.props.whiteLabelSettings.isWhiteLabel}
          label="Feedback Report"
          icon={<IconReport />}
          style={{ margin: 5 }}
          onClick={() => {
            this.setState({
              feedbackReportCategories: _.values(
                this.state.customapp.categories
              ),
            });
            this.refs.feedbackReportDialogue.open();
          }}
        /> 
        <WrapDialogue
          ref="feedbackReportDialogue"
          title="Feedback Report"
          content={
            <div>
              {"Categories to be included in the feedback report:"}
              <br />
              <CategorySelector
                categories={this.state.feedbackReportCategories}
                onDelete={(category) => removeCategoryFromReport(category)}
              />
              <br />
              <ActionButton
                label="Export Feedback Report"
                onClick={() => {
                  exportFeedbackReport();
                }}
              />
              <NormalFlatButton
                label="Cancel"
                onClick={() => this.refs.feedbackReportDialogue.close()}
              />
            </div>
          }
        />*/}
      </div>
    );
  }

  renderMenuButtons() {
    const btnStyle = {
      width: 24,
      height: 24,
      padding: 5,
      margin: 0,
      border:
        "2px solid " +
        (this.props.whiteLabelSettings.isWhiteLabel
          ? this.props.whiteLabelSettings.accentColor
          : "#52829D"),
      borderRadius: 18,
    };
    return (
      <div style={style.topMenuButtonsContainer}>
        <RaisedButton
          label="Custom"
          icon={<img src={IconCustom} style={btnStyle} />}
          style={style.button}
          onClick={() => {
            let planName = "N/A";
            if (this.state.customapp.appInfo.planName) {
              planName = this.state.customapp.appInfo.planName;
            }

            //Because the nav state doesn't fully reset when the custom app changes make sure to set either direction.
            if (
              this.state.customapp.isDischarged &&
              (planName.toLowerCase().includes("N/A") ||
                planName.toLowerCase().includes("starting") ||
                planName.toLowerCase().includes("basic") ||
                planName.toLowerCase().includes("professional"))
            ) {
              alert(
                "This patient has been discharged. You may only add instructions to active patient care plans"
              );
              events().trackUserEvent(
                "Add New Instruction -- Discharged",
                this.state.appId,
                this.state.customapp.customAppId,
                null,
                null,
                this.props.user.userId,
                this.state.customapp.userId,
                "portal",
                this.state.appInfo.appName,
                null,
                null
              );
            } else {
              this.refs.addNewCategoryDialogue.open();
            }
          }}
        />
        <RaisedButton
          label="Library"
          icon={<img src={IconLibrary} style={btnStyle} />}
          style={style.button}
          onClick={() => {
            let planName = "N/A";
            if (this.state.customapp.appInfo.planName) {
              planName = this.state.customapp.appInfo.planName;
            }

            //Because the nav state doesn't fully reset when the custom app changes make sure to set either direction.
            if (
              this.state.customapp.isDischarged &&
              (planName.toLowerCase().includes("N/A") ||
                planName.toLowerCase().includes("starting") ||
                planName.toLowerCase().includes("basic") ||
                planName.toLowerCase().includes("professional"))
            ) {
              alert(
                "This patient has been discharged. You may only add instructions to active patient care plans"
              );
              events().trackUserEvent(
                "Add Library Instruction -- Discharged",
                this.state.appId,
                this.state.customapp.customAppId,
                null,
                null,
                this.props.user.userId,
                this.state.customapp.userId,
                "portal",
                this.state.appInfo.appName,
                null,
                null
              );
            } else {
              this.setState({ libraryDialogOpen: true });
            }
          }}
        />
        <RaisedButton
          label="Print"
          icon={<IconPrint color={"#616161"} style={btnStyle} />}
          style={style.button}
          onClick={() => {
            this.printUserInstructions();
          }}
        />

        <RaisedButton
          label="Copy"
          icon={<IconCopy color={"#616161"} style={btnStyle} />}
          style={style.button}
          onClick={() => this.copyHEPForEMR()}
          tooltip="Copy For EMR"
        />
        <RaisedButton
          label="Goal"
          icon={<img src={IconGoalFlag} style={btnStyle} />}
          style={style.button}
          onClick={() => {
            this.props.history.push(
              `/custom-app-goal/${this.state.appId}/${this.state.userId}`
            );
          }}
        />
        <RaisedButton
          label="Activity"
          icon={<img src={IconActivity} style={btnStyle} />}
          style={style.button}
          onClick={() => {
            this.props.history.push(
              `/patient-progress/${this.state.appId}/${this.state.userId}`
            );
          }}
        />
      </div>
    );
  }

  renderProgramEdit() {
    return (
      <CustomAppProgramEdit
        program={this.state.editProgram}
        close={() => {
          this.setState({ editProgramModalOpen: false, editProgram: null });
          this.props.fetchCustomApp(this.state.appId, this.state.userId);
        }}
        open={this.state.editProgramModalOpen}
        appId={this.state.customapp.appId}
        customAppId={this.state.customapp.customAppId}
      />
    );
  }

  handleDeleteProgram(program) {
    if (this.state.deletingProgramId !== null) {
      return;
    }

    if (
      !window.confirm(
        "Are you sure you want to remove " +
          program.programName +
          " from the care plan?"
      )
    ) {
      return;
    }

    this.setState({ deletingProgramId: program.programId });

    this.clearDeleteRefreshTimeout();
    this.deleteRefreshTimeout = setTimeout(() => {
      this.deleteRefreshTimeout = null;
      this.setState({
        deletingProgramId: null,
        awaitingDeleteRefresh: false,
      });
    }, 20000);

    CustomAppService()
      .removeProgramFromCustomApp(
        this.state.customapp.appId,
        this.state.customapp.customAppId,
        program.programId
      )
      .then((resp) => {
        if (resp && resp.msg === "ok") {
          this.setState({ awaitingDeleteRefresh: true });
          this.props.fetchCustomApp(this.state.appId, this.state.userId);
        } else {
          this.clearDeleteRefreshTimeout();
          this.setState({
            deletingProgramId: null,
            awaitingDeleteRefresh: false,
          });
          alert(
            "Unable to remove program from care plan, please try again. If problems persist please contact AC Health Support"
          );
        }
      })
      .catch(() => {
        this.clearDeleteRefreshTimeout();
        this.setState({
          deletingProgramId: null,
          awaitingDeleteRefresh: false,
        });
        alert(
          "Unable to remove program from care plan, please try again. If problems persist please contact AC Health Support"
        );
      });
  }

  handleEditProgram(program) {
    this.setState({ editProgramModalOpen: true, editProgram: program });
    //Edit program and call to refresh app
  }

  renderProgramsSection() {
    return (
      <div>
        {this.state.customapp &&
          this.state.customapp.programs &&
          this.state.customapp.programs.length > 0 && (
            <div
              style={{
                ...layout.common.subHeading,
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <h4>Assigned Programs</h4>
              <Button
                variant="contained"
                style={{ height: 30 }}
                onClick={() => {
                  this.setState({ programOrderModalOpen: true });
                }}
              >
                Order Programs
                <SortIcon />
              </Button>
            </div>
          )}
        {this.state.customapp && this.state.customapp.programs && this.state.customapp.programs.length > 0 && (
          this.state.customapp.programs.map((p) => {
            const isExpanded = this.state.expandedProviderProgramId === p.programId;
            const isDeleting = this.state.deletingProgramId === p.programId;
            const deleteInFlight = this.state.deletingProgramId !== null;
            return (
              <div key={p.programId}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    border: "solid 1px grey",
                    padding: 10,
                    borderRadius: 7,
                    marginBottom: 10,
                  }}
                >
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <p>{p.programName}</p>
                    <p style={{ marginLeft: 10 }}> -- Start: {p.startDate}</p>
                    {p.endDate && <p style={{ marginLeft: 10 }}>End: {p.endDate}</p>}
                  </div>
                  <div
                    style={{
                      marginLeft: 30,
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <Tooltip
                      id="deleteButton"
                      title={isDeleting ? "Removing..." : "Delete"}
                    >
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: 24,
                          height: 24,
                          flexShrink: 0,
                        }}
                      >
                        {isDeleting ? (
                          <CircularProgress size={20} />
                        ) : (
                          <IconDelete
                            onClick={(e) => {
                              if (!deleteInFlight) {
                                this.handleDeleteProgram(p);
                              }
                              e.stopPropagation();
                            }}
                            style={{
                              cursor: deleteInFlight ? "default" : "pointer",
                              opacity: deleteInFlight ? 0.4 : 1,
                              pointerEvents: deleteInFlight ? "none" : "auto",
                            }}
                            areaLabel="Remove"
                          />
                        )}
                      </span>
                    </Tooltip>
                    <Tooltip id="editButton" title="Edit">
                      <IconEdit
                        onClick={(e) => {
                          this.handleEditProgram(p);
                          e.stopPropagation();
                        }}
                        style={{
                          marginRight: 5,
                          cursor: "pointer",
                        }}
                        areaLabel="Edit"
                      />
                    </Tooltip>
                    <Tooltip id="expandButton" title={isExpanded ? "Collapse" : "Expand"}>
                      <ExpandMoreIcon
                        onClick={(e) => {
                          this.setState({
                            expandedProviderProgramId: isExpanded ? null : p.programId,
                          });
                          e.stopPropagation();
                        }}
                        style={{
                          cursor: "pointer",
                          transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                        }}
                        aria-label={isExpanded ? "Collapse" : "Expand"}
                      />
                    </Tooltip>
                  </div>
                </div>
                {isExpanded && (
                  <div style={{ background: "#f9f9f9", padding: "12px 16px", borderRadius: 4, marginBottom: 8 }}>
                    {(() => {
                      const instructions = Array.isArray(this.state.programInstructions)
                        ? this.state.programInstructions.filter(inst => inst.programId === p.programId)
                        : [];
                      return instructions.length > 0 ? (
                        instructions.map((instruction) => (
                          <InstructionView
                            key={instruction.categoryId || instruction.id}
                            {...instruction}
                            whiteLabelSettings={this.props.whiteLabelSettings}
                          />
                        ))
                      ) : (
                        <div>No instructions available.</div>
                      );
                    })()}
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    );
  }

  renderInstructions() {
    return (
      <div>
        {_.isEmpty(this.state.customapp) && (
          <div>User has not setup customized Channel yet.</div>
        )}

        {!_.isEmpty(this.state.customapp) && (
          <div>
            {this.renderProgramsSection()}
            <div
              style={{
                ...layout.common.subHeading,
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <h4>Instructions</h4>
              <Button
                variant="contained"
                style={{ height: 30 }}
                onClick={() => {
                  this.setState({ orderModalOpen: true });
                }}
              >
                Order Instructions
                <SortIcon />
              </Button>
            </div>
            {_.values(this.state.customapp.categories)
              .filter((inst) => inst.archived === false)
              .map((instruction) => {
                return (
                  <InstructionView
                    {...instruction}
                    onClick={() => this.openInstruction(instruction)}
                    onDeleteClick={() => {
                      this.removeCategory(instruction);
                      this.setState({ needsReset: true });
                    }}
                    onEditClick={() => {
                      this.editCategory(instruction);
                    }}
                    onArchiveActivate={() => {
                      this.archiveActivate(instruction);
                      this.setState({ needsReset: true });
                    }}
                    whiteLabelSettings={this.props.whiteLabelSettings}
                  />
                );
              })}
            {_.values(this.state.customapp.categories)
              .filter((inst) => inst.archived === true)
              .map((instruction) => (
                <InstructionView
                  {...instruction}
                  onClick={() => this.openInstruction(instruction)}
                  onDeleteClick={() => {
                    this.removeCategory(instruction);
                  }}
                  onEditClick={() => {
                    this.editCategory(instruction);
                  }}
                  onArchiveActivate={() => {
                    this.archiveActivate(instruction);
                  }}
                  whiteLabelSettings={this.props.whiteLabelSettings}
                />
              ))}
          </div>
        )}
      </div>
    );
  }

  backPressed() {
    if (
      this.state.customapp.dateOfEval !== null &&
      this.state.customapp.dateOfEval !== undefined
    ) {
      if (this.props.apps.appInfos[this.state.appId].autoTrackTimeInChart) {
        this.props.saveSessionAndClearTimer(
          this.props.user.userId,
          getUserActivityCustomAppIdValueFromStore(),
          getUserActivityCurrentSessionValueFromStore()
        );
        this.logEventAndNavBack();
      } else {
        this.setState({ showPopup: true });
      }
    } else {
      this.logEventAndNavBack();
    }
  }

  setShowPopup(value) {
    this.setState({ showPopup: value });
  }

  logEventAndNavBack() {
    events().trackUserEvent(
      "Close Custom App",
      this.state.appId,
      this.state.customapp.customAppId,
      null,
      null,
      this.props.user.userId,
      null,
      "portal",
      this.state.appInfo.appName,
      null,
      null
    );
    this.props.history.goBack();
  }

  closeOrderModal() {
    this.setState({ orderModalOpen: false });
  }
  openOrderModal() {
    this.setState({ orderModalOpen: true });
  }
  handleSaveOrder() {
    const newOrder = this.state.instructions.map((inst) => {
      return inst.id;
    });
    this.props.reorderCustomAppCategories(
      this.state.appId,
      this.state.customapp.userId,
      this.state.customapp.customAppId,
      newOrder
    );

    this.setState({ orderModalOpen: false, needsReset: true });
  }
  handleSaveProgramOrder() {
    let programOrder = this.state.customapp.programs.map((p) => p.programId);
    CustomAppService()
      .updateAssignedProgramOrder(
        this.state.appId,
        this.state.customapp.customAppId,
        programOrder
      )
      .then((response) => {
        if (response.msg !== "ok") {
          alert(
            "Unable to save program order, please try again. If problems persist please contact AC Health support"
          );
        } else {
          this.setState({ programOrderModalOpen: false });
        }
      });
  }

  render() {
    let targetDevice = "desktop";
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      targetDevice = "mobile";
    }

    return (
      <AppFrame
        auth={this.props.auth}
        targetDevice={targetDevice}
        header="Manage User"
        optionsType="userApp"
        whiteLabelSettings={this.props.whiteLabelSettings}
      >
        <div style={layout.common.page}>
          <Title
            text2={`${this.state.userName}'s Care Plan`}
            goBack={() => this.backPressed()}
            whiteLabelSettings={this.props.whiteLabelSettings}
          />

          <div style={layout.common.mainContainer}>
            {this.renderMenuButtons()}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flex: 1,
                }}
              >
                {this.sendPushNotification(this.state.userName)}
                {this.feedbackReport()}
              </div>

              <div style={style.timerDisplayContainer}>
                <TimerDisplay />
              </div>
            </div>

            {this.renderInstructions()}
            {this.addNewCategory()}
            {this.addLibrary()}
            {this.editCategoryDialogue()}
            {this.viewCategoryDialogue()}
          </div>

          {this.state.showPrint && (
            <div id="printDiv">
              {this.state.customapp &&
                this.state.customapp.categories &&
                Object.keys(this.state.customapp.categories).map((key) => {
                  return (
                    <LibraryInstructionPrint
                      category={this.state.customapp.categories[key]}
                    />
                  );
                })}
            </div>
          )}
        </div>
        <LogInteractionPopup
          showPopup={this.state.showPopup}
          fromChart={true}
          setShowPopup={this.setShowPopup}
          navBack={this.logEventAndNavBack} //Pass in nav back event instead of close popup
          customAppId={this.state.customapp.customAppId}
          patientUserId={this.state.userId}
          providerUserId={this.props.user.userId}
        />
        <Dialog
          onClose={this.closeOrderModal}
          aria-labelledby="customized-dialog-title"
          open={this.state.orderModalOpen}
        >
          <DialogTitle id="customized-dialog-title" onClose={this.closeModal}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                textAlign: "center",
                color: colors.primary,
              }}
            >
              Drag and drop the instructions into the preferred order
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              <Button
                style={{
                  justifySelf: "flex-end",
                  backgroundColor: colors.primary,
                  color: colors.white,
                  marginTop: 10,
                }}
                onClick={this.handleSaveOrder}
              >
                Save Order
              </Button>
            </div>
          </DialogTitle>
          <DialogContent dividers>
            <div>
              <SortableInstruction
                onSortEnd={this.onSortEnd}
                instructions={this.state.instructions}
              ></SortableInstruction>
            </div>
          </DialogContent>
        </Dialog>
        <Dialog
          onClose={() => this.setState({ programOrderModalOpen: false })}
          aria-labelledby="customized-dialog-title"
          open={this.state.programOrderModalOpen}
        >
          <DialogTitle
            onClose={() => this.setState({ programOrderModalOpen: false })}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                textAlign: "center",
                color: colors.primary,
              }}
            >
              Drag and drop the programs into the preferred order
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              <Button
                style={{
                  justifySelf: "flex-end",
                  marginRight: 10,
                  marginTop: 10,
                }}
                onClick={() => this.setState({ programOrderModalOpen: false })}
              >
                Cancel
              </Button>
              <Button
                style={{
                  justifySelf: "flex-end",
                  backgroundColor: colors.primary,
                  color: colors.white,
                  marginTop: 10,
                }}
                onClick={this.handleSaveProgramOrder}
              >
                Save Order
              </Button>
            </div>
          </DialogTitle>
          <DialogContent dividers>
            <div>
              <SortableProgram
                onSortEnd={this.onProgramSortEnd}
                programs={this.state.customapp.programs}
              ></SortableProgram>
            </div>
          </DialogContent>
        </Dialog>
        {this.renderProgramEdit()}
      </AppFrame>
    );
  }
}

function mapStateToProps({
  user,
  apps,
  appusers,
  customapps,
  whiteLabelSettings,
}) {
  return {
    user,
    apps,
    appusers,
    customapps,
    whiteLabelSettings,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...customappsActions, ...userActivityActions },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageUserCustomApp);



// WEBPACK FOOTER //
// ./src/layout/ManageUserCustomApp.js